import { Description } from '@heroui/react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBrand } from '../../../components/ui/app-brand';

export function LandingFooter() {
  return (
    <footer className="border-t border-separator">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="space-y-2">
          <AppBrand iconSize={16} markClassName="size-8 rounded-md" />
          <Description>Sistema de gerenciamento de vagas de garagem.</Description>
        </div>
        <div className="flex flex-col items-start gap-2 sm:items-end">
          <RouterLink
            to="/privacidade"
            className="text-muted text-sm underline-offset-2 hover:text-foreground hover:underline"
          >
            Política de Privacidade
          </RouterLink>
          <Description className="text-sm">© {new Date().getFullYear()} Link Park</Description>
        </div>
      </div>
    </footer>
  );
}
